<template>
  <div
      @dragover.prevent="handleDragOver"
      @dragleave.prevent="handleDragLeave"
      @drop.prevent="handleDrop">
    <slot></slot>
  </div>
</template>

<script>

export default{
  name: "DragView",
  data(){
    return {
      isDragging: false,
    }
  },
  methods:{
    handleDragOver(event) {
      console.log(`dragoverEvent`);
      event.stopPropagation();
      event.preventDefault();
      this.isDragging = true;
      event.dataTransfer.dropEffect = "copy";
    },
    handleDragLeave(event) {
      console.log(`dragleaveEvent`);
      this.isDragging = false;
    },
    handleDrop(event) {
      console.log(`handleDrop`);
      event.preventDefault();
      // @ts-ignore
      const files = event.dataTransfer.files;
      this.$emit('dragFinish', files);
      this.isDragging = false;
    },
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DragView.vue